/**
 * task_type_code → scene_run 运行模式（``--mode``）。
 *
 * 任务类型是数据驱动的（DB 加一行就出现在创建下拉里），但「复制本地仿真命令」
 * 需要知道该类型在平台上是哪种跑法：不带 ``--mode`` 时 scene_run.py 走默认的
 * planning_perfect_control（完美控制），复制出来的命令与实际跑的不是同一条链路。
 *
 * 全站一处收敛：只在这里按 task_type_code 登记跑法，页面不各写一份。
 * 未登记的类型不加 ``--mode``（保持历史行为）。
 *
 * 键必须等于 ``task_type.task_type_code`` 的真实值，不是自增 id
 * （id 是 bigserial，test/prod 不一致，不能用来判类型）。
 */
export const TASK_TYPE_MODE: Record<string, string> = {
  // 感知仿真：真跑 Detection/Recognition 的感知链路
  PE: 'planning_perception',
  // PNC 简单动力学仿真：规划 -> 车动力学 -> 位姿（链路里没有控制模块）
  PLD: 'planning_dynamics',
};

/** 该任务类型本地复现时需要的 ``--mode`` 参数值；未登记返回 undefined。 */
export const taskTypeMode = (taskTypeCode?: string | null): string | undefined => {
  if (!taskTypeCode) return undefined;
  // hasOwnProperty.call：task_type_code 是运维在后台自由填的字符串，直接下标会命中
  // 原型上的成员（constructor / toString / __proto__ 等），返回一个函数而不是
  // undefined，于是复制出来的命令会变成 "--mode function Object() {...}"。
  // 用 hasOwnProperty.call 而不是 Object.hasOwn：本仓 tsconfig 的 lib 低于 ES2022。
  if (!Object.prototype.hasOwnProperty.call(TASK_TYPE_MODE, taskTypeCode)) {
    return undefined;
  }
  return TASK_TYPE_MODE[taskTypeCode];
};